import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Contract2FachbereichEntity } from '../../../entities/mdqx/contract2fachbereich.entity';
import {
    Contract2FachbereichActions,
    Contract2FachbereichActionTypes,
} from '../../actions/mdqx/contract2fachbereich.actions';

export interface Contract2FachbereichState extends EntityState<Contract2FachbereichEntity> {
    fetched: boolean;
}

export const CONTRACT2FACHBEREICH_KEY = 'contract2Fachbereich';

const adapter = createEntityAdapter<Contract2FachbereichEntity>({
    selectId: contract2fachbereich => contract2fachbereich.Id,
});

const initialState: Contract2FachbereichState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contract2FachbereichReducer(
    state = initialState,
    action: Contract2FachbereichActions,
) {
    switch (action.type) {
        case Contract2FachbereichActionTypes.GetResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case Contract2FachbereichActionTypes.PostResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case Contract2FachbereichActionTypes.DeleteResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContract2Fachbereiche = selectAll;

export const selectContract2FachbereicheFetched = (state: Contract2FachbereichState) =>
    state.fetched;
